export const VERSION = {
      number: '2.1.0',
    date: '7th November 2025',
    services: {
      client: '2.1.0',
      server: '2.1.0',
      indexer: '2.0.8'
    }
  };